var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpcoesDeFretePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 256 232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M66 43H37l3-2s3-9 8-9 7 6 7 6 3-3 5-2 3 5 3 5l3 2ZM103 50h37s0-2-5-3c0 0-5-10-12-9-4 1-7 7-7 7s-3-5-6-4c-2 1-4 6-4 6l-3 3ZM83 24h25l-3-3c-1 0-4-7-8-7-4 1-6 6-6 6s-5-1-8 4ZM141 31h22l-2-1s-3-7-7-7c-3 0-5 4-5 4s-1-2-3-1l-2 3-3 2ZM249 58a45 45 0 0 1-26 41 45 45 0 0 1-64-43 45 45 0 0 1 49-43 45 45 0 0 1 41 45ZM125 182c60 0 110-3 110-6 0-4-50-6-110-6-61 0-110 2-110 6 0 3 49 6 110 6ZM118 95l3 62h51l-5-26-17-5a3 3 0 0 1-2-2l-10-26-20-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m169 132-4-1 2 8h3a1 1 0 0 0 0-1v-6a1 1 0 0 0-1 0ZM146 119c-1 1 0 9 1 9l2-1 4-8c-1-2-6 0-7 0ZM120 157H15l6-75 95-5 4 80Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M14 160h161v-5H14v5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m178 153-16 1v7h17l-1-8ZM21 161v-7l-10-1-1 8h11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "evenodd",
    d: "M44 151c-15 0-15 24 0 24 16 0 16-24 0-24Zm0 6c-7 0-7 11 0 11 8 0 8-11 0-11ZM138 151c-16 0-16 24 0 24s16-24 0-24Zm0 6c-7 0-7 11 0 11s7-11 0-11Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M223 191h-17v19h17v-19ZM232 171h-18v20h18v-20ZM246 191h-17v19h17v-19ZM177 211l20-1v-8h-12v2l-7 4-1 3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M177 211a150 150 0 0 0 20-1v-6h-12l-7 4-1 3ZM185 204h13l-3-31 2-8 1-4 3-12 3-9h-11l-3 9-7 24 2 31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m191 211 20-1v-6h-12l-7 4-1 3ZM193 140l1 9 1 1 3 2a4633 4633 0 0 0 1 52h13l-2-30-1-24-1-10h-15ZM198 124c-1 2-3 8-7 12-2 2-14 3-15 3l-3-9h14l8-7c2-2 4-3 3 1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m195 131-7-2 8-7c2-2 3 0 2 2l-3 7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M209 145h-19s4-21 6-24h5c6 5 8 24 8 24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m198 124 3-3-1-2v-2l-4 1a11 11 0 0 1 0 3l2 3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m201 112-2 6c-2 2-4 2-5 0s0-8 1-9c2-1 5 0 6 3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m194 111 1-1 1 1 2-1c2 1 2 2 2 4v2s2-4 1-5c-1-2-3-3-5-2l-2 2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m200 115 1-1c1 1 0 3-1 3a1 1 0 0 1-1-1l1-1ZM195 110l3 1 3 3s1-4-2-5c-3-2-4 1-4 1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m201 113-3-4-5-1 1 3a1 1 0 0 1 1-1l3 1 3 2ZM210 133h-15v17h15v-17ZM195 133h-8v17h8v-17Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M205 123c3 2 10 8 11 12s-3 13-5 14c-1 1-5-3-6-4l4-8-7-12c-3-4-1-5 3-2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M203 146c1 0 1-1 0 0h-5l6-3h4l-5 3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M212 149c-2 2-6 4-9 4h-1l-2-1-2-1-2-1 4-2 8-5 4 6ZM205 131l7-4-9-6c-3-1-3 1-2 3l4 7ZM186 141l-11 1-4-16 11-1 4 16Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "m179 126-5 1v-2h5v1ZM169 133a1 1 0 0 0 1 1l-1 2 1 1a1 1 0 0 0 0 1l1 1v2c1 1 7-1 7-3 1-1-1-1-1-1l2-2-2-1s2-1 1-2h-2l1-2c-1-2-4 1-5 1l-1-2-2 4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpcoesDeFretePlaceholder);
export default __webpack_public_path__ + "static/media/opcoesDeFretePlaceholder.b235a0be7ead38fc3e4c2326b516ddfc.svg";
export { ForwardRef as ReactComponent };